import React, { useCallback, useMemo } from 'react';

import styles from './Fields.module.scss';
import { Icon } from '../../../shared/icon/Icon';
import { SmileyNegative, SmileyNeutral, SmileyPositive } from '../../../shared/icons';
import { SmileyIndicator } from '../../../admin/risk-tolerance/store';

const { green, amber, fixedGrey, lightGrey, red, fixedPrimary } = styles;

interface AnswerIndicatorProps {
    isPositive: boolean;
    isNegative: boolean;
    showNone: boolean;
}

export const AnswerIndicator: React.FC<AnswerIndicatorProps> = ({ isPositive, isNegative, showNone }) => {
    const getColor = useCallback((icon: SmileyIndicator) => {
        if (icon === SmileyIndicator.POSITIVE && isPositive && !showNone) {
            return { fill: green, color: fixedPrimary, fontSize: 36 };
        }
        if (icon === SmileyIndicator.NEGATIVE && isNegative && !showNone) {
            return { fill: red, color: fixedPrimary, fontSize: 36 };
        }
        if (icon === SmileyIndicator.NEUTRAL && !isNegative && !isPositive && !showNone) {
            return { fill: amber, color: fixedPrimary, fontSize: 36 };
        }
        return { fill: lightGrey, color: fixedGrey, fontSize: 28 };
    }, [isPositive, isNegative, showNone]);

    const negativeColor = useMemo(() => getColor(SmileyIndicator.NEGATIVE), [getColor]);
    const neutralColor = useMemo(() => getColor(SmileyIndicator.NEUTRAL), [getColor]);
    const positiveColor = useMemo(() => getColor(SmileyIndicator.POSITIVE), [getColor]);

    return (
        <div className={styles.answerIndicator}>
            <div className={styles.indicatorWrapper}><Icon icon={SmileyNegative} {...negativeColor} /></div>
            <div className={styles.indicatorWrapper}><Icon icon={SmileyNeutral} {...neutralColor} /></div>
            <div className={styles.indicatorWrapper}><Icon icon={SmileyPositive} {...positiveColor} /></div>
        </div>
    );
};
